interface VectorProps {
  className?: string;
  color?: string;
  width?: number | string;
  height?: number | string;
}

export const Vector: React.FC<VectorProps> = ({ className = '', color = 'currentColor', width = 24, height = 24 }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path d="M8 0L8 8L8 16L1.41421 9.41421C0.633163 8.63316 0.633165 7.36683 1.41421 6.58579L8 0Z" fill={color} />
    </svg>
  );
};
